<script setup lang="ts"></script>

<template>
  <svg
    viewBox="0 0 200 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="h-full w-full"
  >
    <defs>
      <filter id="report-glow" x="-50%" y="-50%" width="200%" height="200%">
        <feDropShadow
          dx="0"
          dy="2"
          stdDeviation="8"
          flood-color="#a78bfa"
          flood-opacity="0.5"
        />
      </filter>
    </defs>

    <!-- Outer ring -->
    <circle
      cx="100"
      cy="75"
      r="50"
      fill="none"
      stroke="#e9d5ff"
      stroke-width="1"
      class="pulse-ring"
    />

    <!-- Middle ring - dashed -->
    <circle
      cx="100"
      cy="75"
      r="38"
      fill="none"
      stroke="#ddd6fe"
      stroke-width="1"
      stroke-dasharray="4 4"
    />

    <!-- Central hub with email -->
    <g filter="url(#report-glow)">
      <!-- <circle cx="100" cy="75" r="26" fill="#7c3aed" /> -->
      <circle cx="100" cy="75" r="22" fill="#7c3aed" />
      <!-- Email icon -->
      <rect
        x="90"
        y="69"
        width="20"
        height="14"
        rx="2"
        fill="none"
        stroke="white"
        stroke-width="1.5"
      />
      <path
        d="M90 71 L100 78 L110 71"
        stroke="white"
        stroke-width="1.5"
        fill="none"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>

    <!-- Warning report button -->
    <g class="press">
      <circle
        cx="118"
        cy="93"
        r="9"
        fill="#f5f3ff"
        stroke="#e9d5ff"
        stroke-width="1"
      />

      <!-- Rounded warning triangle -->
      <path
        d="M118 87.8
       L122.8 96
       Q123.2 96.7 122.4 96.7
       H113.6
       Q112.8 96.7 113.2 96
       Z"
        fill="none"
        stroke="#7c3aed"
        stroke-width="1"
        stroke-linejoin="round"
        stroke-linecap="round"
      />

      <!-- Exclamation line -->
      <path
        d="M118 91 L118 93.6"
        stroke="#7c3aed"
        stroke-width="1"
        stroke-linecap="round"
      />

      <!-- Exclamation dot -->
      <circle cx="118" cy="95.3" r="0.6" fill="#7c3aed" />
    </g>
  </svg>
</template>

<style scoped>
@keyframes pulse-ring {
  0%,
  100% {
    opacity: 0.3;
  }
  50% {
    opacity: 0.6;
  }
}
@keyframes press {
  0%,
  100% {
    transform: scale(0.9);
  }
  50% {
    transform: scale(0.85);
  }
}
.pulse-ring {
  animation: pulse-ring 3s ease-in-out infinite;
}
.press {
  animation: press 2s ease-in-out infinite;
  transform-origin: 118px 93px;
}
</style>
